import React from 'react'
type I18nLocale = 'en' | 'es' | 'ja'
interface Props {
  readonly ngTranslate: {
    readonly translate: any
    readonly rootScope: any
  }
}
interface State {
  readonly messages: {
    readonly [key: string]: string
  }
  readonly locale: I18nLocale
}
export function wrapWithI18nBridge(
  WrappedComponent: React.ComponentType<State & Omit<Props, 'ngTranslate'>>
) {
  return function I18nBridge({
    ngTranslate: { translate, rootScope },
    ...props
  }: Props) {
    const [state, setState] = React.useState<State>(() => {
      return {
        locale: translate.use() || 'en',
        messages: translate.getTranslationTable(translate.use() || 'en') || {}
      }
    })
    const isMounted = React.useRef(true)

    React.useEffect(() => {
      translate.onReady(loadLanguageState)
      return () => {
        isMounted.current = false
        if (typeof unregisterTranslateLoadingEnd === 'function') {
          unregisterTranslateLoadingEnd()
        }
        if (typeof unregisterTranslateChangeEnd === 'function') {
          unregisterTranslateChangeEnd()
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    function loadLanguageState() {
      if (!isMounted.current) {
        return
      }
      const locale = translate.use() || 'en'
      const messages = translate.getTranslationTable(locale) || {}
      setState({ locale, messages })
    }
    const unregisterTranslateLoadingEnd = rootScope.$on(
      '$translateLoadingEnd',
      loadLanguageState
    )
    const unregisterTranslateChangeEnd = rootScope.$on(
      '$translateChangeEnd',
      loadLanguageState
    )
    return <WrappedComponent {...state} {...props} />
  }
}
